<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Exportação do Pedido"
    :largura="500"
    transition="dialog-top-transition"
    :ocultar-acoes="resultado_exportacao && resultado_exportacao.sucesso"
  >
    <template #ativador>
      <v-btn color="primary" :class="content_class" small @click="dialog_ativo = ! dialog_ativo">
        <v-icon :size="19" class="mr-1">mdi-file-export</v-icon>
        Exportação Winthor
      </v-btn>
    </template>

    <div class="w-full text-center py-2">
      <template v-if="!resultado_exportacao">
        <v-icon :size="65">mdi-file-export</v-icon>
        <p class="ma-0 py-1 font-15">Deseja realmente exportar esse pedido para o ERP Winthor?</p>
      </template>

      <template v-else-if="resultado_exportacao.sucesso">
        <v-icon color="green" :size="65">mdi-file-check</v-icon>
        <p class="ma-0 py-1 font-16">Exportação realizada com sucesso.</p>
        <p class="ma-0 mt-2 font-14">Pedidos gerados no ERP Winthor:</p>

        <div v-if="resultado_exportacao.resposta_api.orders" class="d-flex align-center justify-center">
          <ul>
            <li v-for="(ordem, key) in resultado_exportacao.resposta_api.orders" :key="key" class="font-14">
              {{ ordem.numeroPedido }}
            </li>
          </ul>
        </div>
      </template>

      <template v-else>
        <v-icon color="red" :size="65">mdi-file-remove</v-icon>
        <p class="ma-0 py-1 font-15">{{ resultado_exportacao.resposta_api }}</p>
      </template>
    </div>

    <template #actions>
      <v-btn
        :disabled="resultado_exportacao && resultado_exportacao.sucesso"
        text color="primary"
        @click="exportarPedido"
      >
        {{ !resultado_exportacao ? 'sim, exportar' : 'tentar novamente' }}
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import {exportarPedido} from "@/api/drp/ExportacaoErp/Winthor";
import {logout} from "@/helpers";

export default {
  name: "ExportacaoPedidoDrpParaErpWinthor",
  components: {
    SysDialog
  },
  props: {
    pedido: Object,
    content_class: String,
  },
  data: () => ({
    dialog_ativo: false,
    resultado_exportacao: null
  }),
  watch: {
    dialog_ativo() {
      if (this.dialog_ativo) return;

      if (this.resultado_exportacao.sucesso) {
        this.$emit('exportacao-realizada-com-sucesso', {});
      }

      setTimeout(() => this.resultado_exportacao = null, 1000);
    }
  },
  methods: {
    exportarPedido() {
      this.$store.dispatch("loading/addRequisicao",
        exportarPedido(this.pedido)
          .then(resposta => this.resultado_exportacao = resposta)
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
